import * as React from 'react';

const InfoSolid = () => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    stroke="none"
    strokeWidth={1}
    fillRule="evenodd"
    fill="#FFFFFF">
    <circle fill="#505FB4" cx={10} cy={10} r={10} />
    <path
      fillRule="nonzero"
      d="M9,14 C9,14.552 9.448,15 10,15 C10.552,15 11,14.552 11,14 L11,10 C11,9.448 10.552,9 10,9 C9.448,9 9,9.448 9,10 L9,14 Z"
    />
    <circle cx={10} cy={6} r={1} />
  </svg>
);

export default InfoSolid;



// WEBPACK FOOTER //
// ./src/assets/images/icons/info-solid.js